import { createFileRoute, redirect } from '@tanstack/react-router';
import { getDefaultStore } from 'jotai';

import { lastAllowedStepAtom } from '@/features/onboarding/atoms/steps';

export const Route = createFileRoute('/_protected/onboarding/')({
  component: () => null,
  beforeLoad: () => {
    const store = getDefaultStore();
    const step = store.get(lastAllowedStepAtom);
    throw redirect({
      to: `/onboarding/${step}`,
      replace: true,
    });
  },
});
